import { createElement, } from 'react';
import SchemaArray from './schmaArray';
import SchemaObject from './schemaObject';
export const mapping = (name, data, showEdit, model, open, index) => {
    const nameArray = [].concat(name, 'properties');
    switch (data.type) {
        case 'array':
            return (createElement(SchemaArray, { prefix: name, data: data, showEdit: showEdit, model: model, open: open, index: index }));
        case 'object':
            return (createElement(SchemaObject, { prefix: nameArray, data: data, showEdit: showEdit, model: model, open: open, index: index }));
        default:
            return null;
    }
};
const JsonSchema = (props) => {
    const { data, showEdit, model, open } = props;
    const item = mapping([], data, showEdit, model, open, '');
    return createElement("div", { className: "schema-content" }, item);
};
export default JsonSchema;
